<div class="intl-phone" (focusout)="onFocusOut($event)" (keydown.escape)="onEscape($event)">
  <button
    #toggleButton
    type="button"
    class="form-control intl-phone__toggle"
    [id]="inputId + '-country'"
    [disabled]="disabled"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-controls]="isOpen ? inputId + '-listbox' : null"
    title="Selecionar país"
    aria-label="Selecionar país"
    (click)="toggle()"
    (keydown.arrowdown)="openFromKeyboard($event)"
  >
    <span class="fi intl-phone__flag" [ngClass]="'fi-' + selectedCountry.iso2.toLowerCase()"></span>
    <span class="intl-phone__dial">+{{ selectedCountry.dialCode }}</span>
  </button>

  <input
    #phoneInput
    type="tel"
    class="form-control intl-phone__input"
    autocomplete="off"
    [id]="inputId"
    [disabled]="disabled"
    [attr.maxlength]="maxLength"
    [value]="displayValue"
    (input)="onInput()"
    (paste)="onPaste($event)"
  />

  <div class="intl-phone__panel" *ngIf="isOpen">
    <input
      #searchInput
      type="text"
      class="form-control intl-phone__search"
      placeholder="Buscar país"
      aria-label="Buscar país"
      role="combobox"
      aria-autocomplete="list"
      aria-expanded="true"
      [attr.aria-controls]="inputId + '-listbox'"
      [attr.aria-activedescendant]="filteredCountries.length ? inputId + '-option-' + activeIndex : null"
      autocomplete="off"
      [value]="search"
      (input)="onSearch($any($event.target).value)"
      (keydown)="onSearchKeydown($event)"
    />
    <ul class="intl-phone__list" role="listbox" aria-label="Países" [id]="inputId + '-listbox'">
      <li
        *ngFor="let c of filteredCountries; let i = index"
        class="intl-phone__item"
        role="option"
        [id]="inputId + '-option-' + i"
        [class.selected]="c.iso2 === country"
        [class.active]="i === activeIndex"
        [attr.aria-selected]="c.iso2 === country"
        (mousedown)="$event.preventDefault()"
        (click)="select(c)"
      >
        <span class="fi intl-phone__flag" [ngClass]="'fi-' + c.iso2.toLowerCase()"></span>
        <span class="intl-phone__dial">+{{ c.dialCode }}</span>
        <span class="intl-phone__name">{{ c.name }}</span>
      </li>
      <li *ngIf="!filteredCountries.length" class="intl-phone__empty">Nenhum país encontrado</li>
    </ul>
  </div>
</div>
